import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import awaitAccessToken from '../../modules/awaitAccessToken'
import updateCustomerProduct from '../../actions/customerProducts/updateCustomerProduct'

const onUpdateCustomerProduct = function* onUpdateCustomerProduct() {
  yield takeLatest(actionTypes.CUSTOMER_PRODUCTS.UPDATE, function* onUpdateCustomerProductSaga(action) {
    const accessToken = yield call(awaitAccessToken)
    const { payload } = action

    let response
    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.customers}/products/${payload.id}`,
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Infowijs-Client': 'nl.infowijs.admin',
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
        },
        data: payload,
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reUpdateCustomerProduct() {
          yield put(updateCustomerProduct(payload))
        })
      }

      rejectAction(action, e.response.data.errors || 'An unknown error occurred')

      return
    }

    if (!response || !response.data) {
      return
    }

    acceptAction(action, response.data.data)
  })
}

export default onUpdateCustomerProduct
